// Reine Entscheidungslogik ohne React, Netzwerk oder Uhr.
//
// Hier liegen genau die Stellen, an denen im laufenden Betrieb Fehler
// aufgetreten sind: die Timer-Berechnung beim Start/Fortsetzen und die
// Erkennung wiederholter Songs. Beide waren vorher inline in App.js
// verwoben und nur durch echtes Durchspielen prüfbar.

/** Spieldauer der Jahres-Runde: tippen dauert laenger als buzzern. */
export const JAHR_DAUER_MS = 30000;

/** Restzeit eines laufenden Countdowns. null = kein Zeitlimit gesetzt. */
export function remainingFromDeadline(deadlineMs, nowMs) {
  if (deadlineMs === null || deadlineMs === undefined) return 0;
  return Math.max(0, deadlineMs - nowMs);
}

/**
 * Wie lange läuft die Musik ab jetzt?
 *
 * mode:
 *  "fresh"     — neuer Song, volles Zeitlimit
 *  "resume"    — nach STOPP weiterhören: an der gestoppten Stelle weiter.
 *                War die Zeit schon abgelaufen (savedRemainingMs === 0),
 *                gilt bewusst KEIN Limit mehr — sonst würde der Song
 *                sofort wieder stoppen.
 *  "unlimited" — bewusst ohne Zeitlimit (z.B. nach der Bewertung)
 *
 * Rückgabe: Dauer in ms, oder null für "kein Zeitlimit".
 */
export function resolveStartDurationMs(mode, { timeLimit, taskType, savedRemainingMs }) {
  if (mode === "resume") {
    return savedRemainingMs > 0 ? savedRemainingMs : null;
  }
  if (mode === "fresh") {
    const limitMs = timeLimit > 0 ? timeLimit * 1000 : null;
    // Die Jahres-Runde braucht laenger als die anderen: hier wird nicht
    // gebuzzert, sondern getippt und abgeschickt. Das eingestellte Limit
    // gilt weiterhin, es kann die Runde nur nicht unter 30 s druecken.
    if (taskType === "YEAR") return Math.max(limitMs || 0, JAHR_DAUER_MS);
    return limitMs;
  }
  return null;
}

/**
 * Was tun, wenn Spotify uns den aktuellen Song meldet?
 *
 * "reset"  — neue Playlist, Song-Historie neu beginnen
 * "append" — noch nicht gespielter Song, merken
 * "warn"   — Song lief in dieser Runde schon: Playlist vermutlich durch
 * "none"   — nichts zu tun
 *
 * Entscheidend: Bei isSameSong IMMER "none". Der Poll während der
 * Wiedergabe fragt alle 3s denselben Song erneut ab (mit forceUpdate, um
 * die Songdaten frisch zu halten). Lief das Tracking dabei mit, sah der
 * gerade laufende Song sich selbst in playedSongs und löste die
 * Wiederholungs-Warnung aus — kurz nach dem allerersten Song.
 */
export function decideSongTracking({
  isSameSong,
  newContextUri,
  prevContextUri,
  playedSongs,
  songId,
  warningMuted,
}) {
  if (isSameSong) return "none";
  if (newContextUri !== prevContextUri) return "reset";
  if (!playedSongs.includes(songId)) return "append";
  if (!warningMuted) return "warn";
  return "none";
}
